<script>

    import NormalLabel from 'southcn-ui2/src/components/widgets/NormalLabel';
    import NormalInput from 'southcn-ui2/src/components/widgets/NormalInput';
    import ModalFooter from 'southcn-ui2/src/components/modals/ModalFooter';
    import NormalButton from 'southcn-ui2/src/components/widgets/NormalButton';
    import ModalHeader from 'southcn-ui2/src/components/modals/ModalHeader';
    import md5 from 'md5';
    import { pwdCheckedReg } from '../../lib/changePwd';

    const STEP_VALUES = {
        PASSWORD_PASSWORD_1: 'password_password_1',
        PASSWORD_PASSWORD_2: 'password_password_2',
        PASSWORD_PASSED_2: 'password_passed_2',
        PASSWORD_SMS_1: 'password_sms_1',
        PASSWORD_SMS_2: 'password_sms_2',
        PHONEUNBIND_PASSWORD_2: 'phoneUnbind_password_2',
        PHONEUNBIND_SMS_2: 'phoneUnbind_sms_2',
        PHONEUNBIND_WECHAT_2: 'phoneUnbind_wechat_2',
        PHONEBIND_PASSWORD_1: 'phoneBind_password_1',
        PHONEBIND_PASSWORD_2: 'phoneBind_password_2',
        PHONEBIND_SMS_1: 'phoneBind_sms_1',
        PHONEBIND_PASSED_2: 'phoneBind_passed_2',
        WECHATUNBIND_PASSWORD_2: 'wechatUnbind_password_2',
        WECHATUNBIND_SMS_2: 'wechatUnbind_sms_2',
        WECHATUNBIND_WECHAT_2: 'wechatUnbind_wechat_2',
        WECHATBIND_PASSWORD_1: 'wechatBind_password_1',
        WECHATBIND_SMS_1: 'wechatBind_sms_1',
        WECHATBIND_PASSWORD_2: 'wechatBind_password_2',
        WECHATBIND_SMS_2: 'wechatBind_sms_2',
        EMAIL_PASSWORD_1: 'email_password_1',
        EMAIL_SMS_1: 'email_sms_1',
        EMAIL_PASSWORD_2: 'email_password_2',
        EMAIL_SMS_2: 'email_sms_2',
        EMAIL_PASSED_2: 'email_passed_2',
    };
    const TEXT_MAP = {
        code: '验证码',
        password: '密码',
        sms: '短信验证码'
    };

    export default {
        alias: 'auth',
        defaultOptions () {
            return {
                title: ''
            };
        },
        modalCreated (options) {
            // const _this = this;
            const cacheInfo = this.info;
            for (let key in options) {
                this[key] = options[key];
            }
            this.info = Object.assign(cacheInfo, this.info);
            this.step = this.setting.includes('Unbind') ? 2 : 1;
            if (this.setting === 'phoneBind' && this.currStep === 2) {
                this.refreshCaptcha();
                // this.requestStep = false;
                // setTimeout(function () {
                //     _this.$bus.$emit('visibility-change', true);
                // }, 1000)
                // this.$bus.$on('allRequest-finish', () => {
                //     // 避免
                //     if (!_this.requestStep) {
                //         _this.refreshCaptcha();
                //         _this.requestStep = true
                //     }

                // });
            }
        },
        beforeDestroy () {
            clearInterval(this.sceneVerifyTimer);
            clearInterval(this.emailTimer);
            clearInterval(this.smsTimer);
        },
        data () {
            return {
                isHideClose: false,
                title: '',
                isDrag: true,
                setting: 'password',
                currStep: 0,
                captchaImg: '',
                codeImageUrl: '',
                imgCode: '',
                info: {
                    code: '',
                    authWay: '',
                    password_verify_value: '',
                    wx_verify_value: '',
                    new_phone: '',
                    new_phone_code: '',
                    new_email: '',
                    new_email_code: '',
                    sms_verify_value: '',
                    new_password: '',
                    phone: ''
                },
                step: 1,
                phoneCodeBtnText: '获取验证码',
                emailCodeBtnText: '获取验证码',
                requestStep: true
            };
        },
        name: 'modal-auth',
        methods: {
            refreshCaptcha () {
                this.captchaImg = `${ this.$config.apiUrl.captcha }?_r=${ Math.random() }`;
            },
            onClose () {
            },
            onConfirm () {
                if (this.currStep >= 3) {
                    this.okCallback && this.okCallback(this.info);
                    this.close();
                    return;
                }
                const stepValue = `${ this.setting }_${ this.info.authWay }_${ this.currStep }`;
                console.log(stepValue);
                switch (stepValue) {
                    case STEP_VALUES.PASSWORD_PASSWORD_1:
                        this.validateAuth('password');
                        break;
                    case STEP_VALUES.PASSWORD_PASSWORD_2:
                        this.fetchUpdatePwd();
                        break;
                    case STEP_VALUES.PASSWORD_SMS_1:
                        this.validateAuth('sms');
                        break;
                    case STEP_VALUES.PASSWORD_SMS_2:
                        this.fetchUpdatePwd();
                        break;
                    case STEP_VALUES.PHONEUNBIND_PASSWORD_2:
                        this.fetchUnbindPone('password');
                        break;
                    case STEP_VALUES.PHONEUNBIND_SMS_2:
                        this.fetchUnbindPone('sms');
                        break;
                    case STEP_VALUES.PHONEUNBIND_WECHAT_2:
                        this.fetchUnbindPone('wechat');
                        break;
                    case STEP_VALUES.PHONEBIND_PASSWORD_1:
                        this.validateAuth('password');
                        break;
                    case STEP_VALUES.PHONEBIND_PASSWORD_2:
                        this.fetchBindPone();
                        break;
                    case STEP_VALUES.PHONEBIND_PASSED_2:
                        this.fetchBindPone();
                        break;
                    case STEP_VALUES.EMAIL_PASSED_2:
                        this.fetchUpdateEmail();
                        break;
                    case STEP_VALUES.PASSWORD_PASSED_2:
                        this.fetchUpdatePwd();
                        break;
                    case STEP_VALUES.WECHATUNBIND_PASSWORD_2:
                        this.fetchUnbindWechat('password');
                        break;
                    case STEP_VALUES.WECHATUNBIND_SMS_2:
                        this.fetchUnbindWechat('sms');
                        break;
                    case STEP_VALUES.WECHATBIND_PASSWORD_1:
                        this.validateAuth('password', () => {
                            this.genWxCode('wx-bind-frame', 'bindWxCb');
                        });
                        break;
                    case STEP_VALUES.WECHATBIND_SMS_1:
                        this.validateAuth('sms', () => {
                            this.genWxCode('wx-bind-frame', 'bindWxCb');
                        });
                        break;
                    case STEP_VALUES.EMAIL_PASSWORD_1:
                        this.validateAuth('password');
                        break;
                    case STEP_VALUES.EMAIL_PASSWORD_2:
                        this.fetchUpdateEmail();
                        break;
                    case STEP_VALUES.EMAIL_SMS_1:
                        this.validateAuth('sms');
                        break;
                    case STEP_VALUES.EMAIL_SMS_2:
                        this.fetchUpdateEmail();
                        break;
                }
                // if (this.setting === 'password')
                //     this.currStep += this.step;
            },
            onPreStep () {
                if (this.info.authWay === 'passed') {
                    this.currStep -= 2;
                    return;
                }
                this.currStep -= this.step;
            },
            validatorNewPwd (val) {
                if (
                    !val.match(pwdCheckedReg)
                ) {
                    return '密码必须大于8位，且包含数字、大小写字母和特殊字符';
                }
            },
            validatorPhone (val, code) {
                if (!val) {
                    return '请输入手机号码';
                } else if (!this.$util.validate.mobile(val)) {
                    return '请输入正确格式的手机号码';
                } else if (!this.imgCode) {
                    return '请输入图形验证码';
                } else if (!code) {
                    return '请输入短信验证码';
                }
            },
            validatorEmail (val, code) {
                if (!val) {
                    return '请输入邮箱地址';
                } else if (!this.$util.validate.email(val)) {
                    return '请输入正确格式的邮箱';
                } else if (!code) {
                    return '请输入邮箱验证码';
                }
            },
            async fetchUpdatePwd () {
                const verify_value = this.info.new_password;
                const validate = this.validatorNewPwd(verify_value);
                if (validate) {
                    this.$alias.message.error(validate);
                    return;
                }
                try {
                    await this.$api(this.$config.apiUrl.editPwd, {
                        'new': md5(verify_value)
                    });
                    this.currStep += 1;
                } catch (e) {
                    this.$alias.message.error(`密码修改失败：${ e.errmessage }`);
                }
            },
            async fetchUnbindPone (verify_type, cb) {
                let verify_value = this.info[`${ verify_type }_verify_value`];
                if (verify_type === 'sms' && !this.imgCode) {
                    this.$alias.message.error(`请输入图形验证码`);
                    return;
                }
                if (!verify_value) {
                    this.$alias.message.error(`请输入${ TEXT_MAP[verify_type] }`);
                    return;
                }
                if (verify_type === 'password') {
                    verify_value = md5(verify_value);
                    if (!this.info.code) {
                        this.$alias.message.error(`请输入${ TEXT_MAP['code'] }`);
                        return;
                    }
                }
                try {
                    const params = {verify_type, verify_value, code: this.info.code};
                    await this.$api(this.$config.apiUrl.authSelf, params);
                    await this.$api(this.$config.apiUrl.unBindPhone, params);
                    this.currStep += 1;
                    cb && cb();
                } catch (e) {
                    this.$alias.message.error(`手机解绑失败：${ e.errmessage }`);
                }
            },
            async fetchUnbindWechat (verify_type, cb) {
                let verify_value = this.info[`${ verify_type }_verify_value`];
                if (verify_type === 'sms' && !this.imgCode) {
                    this.$alias.message.error(`请输入图形验证码`);
                    return;
                }
                if (!verify_value) {
                    this.$alias.message.error(`请输入${ TEXT_MAP[verify_type] }`);
                    return;
                }
                if (verify_type === 'password') {
                    verify_value = md5(verify_value);
                    if (!this.info.code) {
                        this.$alias.message.error(`请输入${ TEXT_MAP['code'] }`);
                        return;
                    }
                }
                try {
                    const params = {verify_type, verify_value, code: this.info.code};
                    await this.$api(this.$config.apiUrl.authSelf, params);
                    await this.$api(this.$config.apiUrl.unBindWx, params);
                    this.setUserData('wx', false);
                    cb && cb();
                    this.currStep += 1;
                } catch (e) {
                    this.refreshCaptcha();
                    this.$alias.message.error(`微信解绑失败：${ e.errmessage }`);
                }
            },
            setUserData (prop, val) {
                this.user[prop] = val;
                this.$store.commit('user', this.user);
            },
            async fetchBindPone () {
                const {new_phone: phone, new_phone_code: code} = this.info;
                const validate = this.validatorPhone(phone, code);
                if (validate) {
                    this.$alias.message.error(validate);
                    return;
                }
                try {
                    await this.$api(this.$config.apiUrl.bindPhone, {
                        phone, code
                    });
                    this.currStep += 1;
                } catch (e) {
                    this.$alias.message.error(`手机绑定失败：${ e.errmessage }`);
                }
            },
            async fetchUpdateEmail () {
                const {new_email: email, new_email_code: code} = this.info;
                const validate = this.validatorEmail(email, code);
                if (validate) {
                    this.$alias.message.error(validate);
                    return;
                }
                try {
                    await this.$api(this.$config.apiUrl.editEmail, {
                        email, code
                    });
                    this.currStep += 1;
                } catch (e) {
                    this.$alias.message.error(`修改邮箱失败：${ e.errmessage }`);
                }
            },
            async validateAuth (verify_type, cb) {
                let verify_value = this.info[`${ verify_type }_verify_value`];
                if (verify_type === 'sms' && !this.imgCode) {
                    this.$alias.message.error(`请输入图形验证码`);
                    return;
                }
                if (!verify_value) {
                    this.$alias.message.error(`请输入${ TEXT_MAP[verify_type] }`);
                    return;
                }
                if (verify_type === 'password') {
                    if (!this.info.code) {
                        this.$alias.message.error(`请输入${ TEXT_MAP['code'] }`);
                        return;
                    }
                    verify_value = md5(verify_value);
                }
                try {
                    await this.$api(this.$config.apiUrl.authSelf, {
                        verify_type,
                        verify_value,
                        code: this.info.code
                    });
                    this.currStep += 1;
                    cb && cb();
                } catch (e) {
                    this.refreshCaptcha();
                    this.$alias.message.error(`身份验证失败：${ e.errmessage }`);
                }
            },
            handleAuthWay (type) {
                this.info.authWay = type;
                this.currStep += this.step;
                this.refreshCaptcha();
                if (type === 'wechat') {
                    this.$nextTick(() => {
                        let keys = 'authWxCb';
                        if (this.setting === 'password' || this.setting === 'phoneBind' || this.setting === 'email') {
                            keys = 'authWxCb';
                        } else if (this.setting === 'phoneUnbind') {
                            keys = 'unbindPhoneWx';
                        } else if (this.setting === 'wechatUnbind') {
                            keys = 'unBindWxCb';
                        } else if (this.setting === 'wechatBind') {
                            keys = 'bindWxCb';
                        }
                        this.genWxCode('wx-unbind-frame', keys);
                    });
                }
            },
            async fetchSendPhoneCode (phone) {
                console.log(this.setting);
                const operationMap = {
                    phoneBind: 'bind_phone',
                    phoneUnbind: 'unbind_phone',
                    wechatUnbind: 'unbind_wx',
                    wechatBind: 'bind_wx',
                    email: 'modify_email',
                    password: 'modify_password'
                };
                if (this.phoneCodeBtnText !== '获取验证码') {
                    return;
                }
                if (!this.imgCode) {
                    this.$alias.message.error('请输入图形验证码');
                    return;
                }
                if (!this.$util.validate.mobile(phone)) {
                    this.$alias.message.error('请输入正确格式的手机号码');
                    return;
                }
                try {
                    // await this.$api('/debug/vericode/sms', {
                    //     phone
                    // });
                    await this.$api(this.$config.apiUrl.sendPhoneCode, {
                        code: this.imgCode,
                        phone,
                        operation: operationMap[this.setting]
                    });
                    this.$alias.message.ok('验证码发送成功');
                    this.phoneCodeBtnText = '60s';
                    this.smsTimer = setInterval(() => {
                        let text = parseInt(this.phoneCodeBtnText);
                        if (text > 1) {
                            text -= 1;
                            text = `${ text }s`;
                        } else {
                            text = '获取验证码';
                            window.clearInterval(this.smsTimer);
                        }
                        this.phoneCodeBtnText = text;
                    }, 1000);
                } catch (e) {
                    this.$alias.message.error(`验证码发送失败：${ e.errmessage === '验证码错误' ? '图形验证码错误' : e.errmessage }`);
                    this.refreshCaptcha();
                }
            },
            async fetchSendEmailCode (email) {
                if (this.emailCodeBtnText !== '获取验证码') {
                    return;
                }
                if (!email) {
                    this.$alias.message.error('请输入邮箱地址');
                    return;
                } else if (!this.$util.validate.email(email)) {
                    this.$alias.message.error('请输入正确格式的邮箱地址');
                    return;
                }
                try {
                    // await this.$api('/debug/vericode/email', {
                    //     email
                    // });
                    await this.$api(this.$config.apiUrl.sendEmailCode, {
                        email
                    });
                    this.$alias.message.ok('验证码发送成功');
                    this.emailCodeBtnText = '60s';
                    this.emailTimer = setInterval(() => {
                        let text = parseInt(this.emailCodeBtnText);
                        if (text > 1) {
                            text -= 1;
                            text = `${ text }s`;
                        } else {
                            text = '获取验证码';
                            window.clearInterval(this.emailTimer);
                        }
                        this.emailCodeBtnText = text;
                    }, 1000);
                } catch (e) {
                    this.$alias.message.error(`验证码发送失败：${ e.errmessage }`);
                }
            },
            async getWxImage (key) {
                try {
                    const result = await this.$api(this.$config.apiUrl.wxSubcribeUrl, {
                        action: key === 'bindWxCb' ? 'logined_bind' : 'logined_check'
                    });
                    this.codeImageUrl = result.url;
                    this.sceneVerifyTimer && clearInterval(this.sceneVerifyTimer);
                    this.startSceneVerifyTimer(key);
                } catch (error) {
                    this.$alias.error(`获取服务号二维码图片失败：${ error.errmessage }`);
                }
            },
            startSceneVerifyTimer (key) {
                this.sceneVerifyTimer = setInterval(async () => {
                    try {
                        await this.$api(this.$config.apiUrl.wxSubcribeCheck);
                        this.sceneVerifyTimer && clearInterval(this.sceneVerifyTimer);
                        this.switchWxHandle(key);
                    } catch (e) {
                        if (e.errcode === 1240) {
                            this.sceneVerifyTimer && clearInterval(this.sceneVerifyTimer);
                            this.getWxImage(key);
                        } else if (e.errcode !== 1241) {
                            this.$alias.error(`扫码出错：${ e.errmessage }`);
                        }
                    }
                }, 5000);
            },
            switchWxHandle (key) {
                console.log(key);
                this.info.wx_verify_value = 'wechat';
                switch (key) {
                    case 'bindWxCb':
                        this.setUserData('wx', true);
                        this.currStep += 1;
                        break;
                    case 'unBindWxCb':
                        this.fetchUnbindWechat('wx', () => {
                            this.info.authWay = 'passed';
                        });
                        break;
                    case 'unbindPhoneWx':
                        this.fetchUnbindPone('wx', () => {
                            this.info.authWay = 'passed';
                        });
                        break;
                    case 'authWxCb':
                        this.validateAuth('wx', () => {
                            this.info.authWay = 'passed';
                        });
                        break;
                }
            },
            async genWxCode (id = 'wx-unbind-frame', keys = 'authWxCb') {
                /**
                 * wx_oauth为3表示混合模式
                 * 这里原逻辑为混合模式时调用服务号的二维码,否则调用网站应用的二维码。
                 * 现需求为混合模式且未绑定微信时使用服务号二维码
                 * 否则使用网站应用二维码
                 */

                //3.10oldCode
                // if (this.$store.state.appUrls.wx_oauth === '3') {
                //     return this.getWxImage(keys);
                // }
                // let state = '';
                // if (keys === 'bindWxCb') {
                //     state = await this.$api(this.$config.apiUrl.wxCreate);
                //     state = state.state;
                // }

                //3.10newCode
                console.log(this.$store.state.appUrls);
                if (this.$store.state.appUrls.wx_oauth === '3' && !this.user.wx) {
                    return this.getWxImage(keys);
                }
                let state = '';
                if (keys === 'bindWxCb') {
                    state = await this.$api(this.$config.apiUrl.wxCreate);
                    state = state.state;
                }

                let api = this.$config.apiUrl[keys];
                let redirect_uri = `${ this.$config.getRootUrl() }/usercenter/personal/#index?authWay=passed&setting=${ this.setting }&currStep=${ (this.step === 2 || keys === 'bindWxCb') ? 3 : (this.currStep + 1) }`;
                api = `${ this.$config.getRootUrl() }${ api }?redirect_url=${ window.encodeURIComponent(redirect_uri) }`;
                api = window.encodeURIComponent(api);
                return new window.WxLogin({
                    id,
                    appid: this.$store.state.appUrls.wx_appid,
                    scope: 'snsapi_login',
                    redirect_uri: api,
                    state: state,
                    style: '',
                    href: `https://cloud.gd.gov.cn/static/core/css/wechat-qrcode.css`
                });
            }
        },
        components: {
            ModalHeader,
            NormalButton,
            ModalFooter,
            NormalLabel,
            NormalInput
        },
        computed: {
            modalStep1 () {
                return this.currStep;
            },
            smsBtnDisabled () {
                return !this.user.phone || this.setting === 'phoneBind';
            },
            wechatBtnDisabled () {
                return !this.user.wx || this.setting === 'wechatBind';
            },
            user () {
                return this.$store.state.user;
            },
            stepObj () {
                return [
                    {
                        text: this.setting.includes('Unbind') ? '选择方式' : '验证方式',
                        value: 'one',
                        num: 0,
                        numText: 1
                    },
                    {
                        text: this.setting.includes('Unbind') ? '身份验证' : '设置修改',
                        value: 'two',
                        num: 2,
                        numText: 2
                    },
                    {
                        text: '完成',
                        value: 'three',
                        num: 3,
                        numText: 3
                    }
                ];
            }
        },
        mounted () {
        },
        watch: {}
    };
</script>

<template>
    <div class="modal" :class="`modal-curstep-${currStep} modal-authway-${info.authWay}`">
        <modal-header :text="title" :is-drag="true" :is-hide-close="isHideClose" @close="onClose"></modal-header>
        <div class="modal-content">
            <div class="step-box">
                <div
                    class="step-box__item"
                    :class="[`step-${item.value}`, {
                        active: currStep >= item.num,
                        complete: currStep > item.num,
                        loading: currStep === item.num
                    }]"
                    :key="item.value"
                    v-for="item in stepObj"
                >
                    <span class="step-box__item-num">{{ item.numText }}</span>
                    <span class="step-box__item-text">{{ item.text }}</span>
                </div>
            </div>
            <div class="step-panel-wrapper">
                <div class="step-panel step-panel-0" v-if="currStep === 0">
                    <div class="row x1">
                        <normal-button
                            @click="handleAuthWay('password')"
                            class="auth-way-btn"
                            float="none"
                        >登录密码
                        </normal-button>
                    </div>
                    <div class="row x1">
                        <normal-button
                            @click="handleAuthWay('sms')"
                            :disabled="smsBtnDisabled"
                            class="auth-way-btn"
                            float="none"
                        >短信验证码
                        </normal-button>
                    </div>
                    <div class="row x1">
                        <normal-button
                            @click="handleAuthWay('wechat')"
                            :disabled="wechatBtnDisabled"
                            class="auth-way-btn"
                            float="none"
                        >微信验证
                        </normal-button>
                    </div>
                </div>
                <div
                    class="step-panel step-panel-0"
                    :class="`step-panel-${info.authWay}`"
                    v-if="(!setting.includes('Unbind') && currStep === 1) || (setting.includes('Unbind') && currStep === 2)"
                >
                    <template v-if="info.authWay === 'password'">
                        <div class="row x1 use-password">
                            <normal-label :marginRight="2">当前密码</normal-label>
                            <normal-input
                                type="password"
                                v-model="info.password_verify_value"
                                :showError="true"
                                :showPassword="true"
                            ></normal-input>
                        </div>
                        <div class="row x1 use-password">
                            <normal-label :marginRight="2">验证码</normal-label>
                            <normal-input
                                type="text"
                                class="captcha-input"
                                v-model="info.code"
                                :showError="true"
                            ></normal-input>
                            <div class="captcha-view" ref="captcha_view" @click="refreshCaptcha">
                                <img :src="captchaImg" alt/>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="info.authWay === 'sms'">
                        <div class="row x1 use-sms">
                            <normal-label>当前手机号</normal-label>
                            <normal-label>{{ user.phone }}</normal-label>
                        </div>
                        <div class="row x1 use-sms">
                            <normal-label>图形验证码</normal-label>
                            <normal-input type="text" v-model="imgCode" :showError="true"></normal-input>
                            <div class="captcha-view" style="right: 4px" @click="refreshCaptcha">
                                <img :src="captchaImg + '1'" alt/>
                            </div>
                        </div>
                        <div class="row x1 use-sms">
                            <normal-label>短信验证码</normal-label>
                            <normal-input v-model="info.sms_verify_value"></normal-input>
                            <normal-button
                                float="right"
                                :disabled="phoneCodeBtnText !== '获取验证码'"
                                @click="fetchSendPhoneCode(user.phone)"
                            >{{ phoneCodeBtnText }}
                            </normal-button>
                        </div>
                    </template>
                    <template v-else-if="info.authWay === 'wechat'">
                        <div class="row use-wechat">
                            <div v-if="!codeImageUrl" class="wx-bind-frame" id="wx-unbind-frame"></div>
                            <div v-else class="wx-bind-frame">
                                <img :src="codeImageUrl" alt="微信二维码"/>
                            </div>
                            <p class="text">请使用微信扫描二维码验证</p>
                        </div>
                    </template>
                </div>
                <div
                    class="step-panel step-panel-2"
                    :class="`step-panel-${setting}`"
                    v-if="(!setting.includes('Unbind') && currStep === 2)"
                >
                    <div v-if="setting === 'password'">
                        <div class="row x1 use-password">
                            <normal-label :marginRight="2">新密码</normal-label>
                            <normal-input
                                type="password"
                                autocomplete="new-password"
                                v-model="info.new_password"
                                :showPassword="true"
                            ></normal-input>
                        </div>
                    </div>
                    <template v-else-if="setting === 'wechatBind'">
                        <div class="row use-wechat">
                            <div v-if="!codeImageUrl" class="wx-bind-frame" id="wx-bind-frame"></div>
                            <div v-else class="wx-bind-frame">
                                <img :src="codeImageUrl" alt="微信二维码"/>
                            </div>
                            <p class="text">请使用微信扫描二维码绑定</p>
                        </div>
                    </template>
                    <template v-else-if="setting === 'email'">
                        <div class="row x1 use-sms">
                            <normal-label>新邮箱</normal-label>
                            <normal-input v-model="info.new_email"></normal-input>
                        </div>
                        <div class="row x1 use-sms">
                            <normal-label>验证码</normal-label>
                            <normal-input v-model="info.new_email_code"></normal-input>
                            <normal-button
                                float="right"
                                :disabled="emailCodeBtnText !== '获取验证码'"
                                @click="fetchSendEmailCode(info.new_email)"
                            >{{ emailCodeBtnText }}
                            </normal-button>
                        </div>
                    </template>
                    <template v-else-if="setting === 'phoneBind'">
                        <div class="row x1 use-sms">
                            <normal-label>手机号码</normal-label>
                            <normal-input v-model="info.new_phone"></normal-input>
                        </div>
                        <div class="row x1 use-sms">
                            <normal-label>图形验证码</normal-label>
                            <normal-input type="text" v-model="imgCode" :showError="true"></normal-input>
                            <div
                                v-if="requestStep"
                                class="captcha-view"
                                style="right: 4px"
                                @click="refreshCaptcha"
                            >
                                <img :src="captchaImg + '1'" alt/>
                            </div>
                        </div>
                        <div class="row x1 use-sms">
                            <normal-label>短信验证码</normal-label>
                            <normal-input v-model="info.new_phone_code"></normal-input>
                            <normal-button
                                float="right"
                                :disabled="phoneCodeBtnText !== '获取验证码'"
                                @click="fetchSendPhoneCode(info.new_phone)"
                            >{{ phoneCodeBtnText }}
                            </normal-button>
                        </div>
                    </template>
                </div>
                <div class="step-panel step-panel-3" v-show="currStep >= 3">
                    <normal-label
                        class="modal-auth-complete"
                        float="none"
                        prefix-icon="&#xe6f8;"
                    >操作成功
                    </normal-label>
                </div>
            </div>
        </div>
        <modal-footer v-if="currStep">
            <normal-button
                @click="onConfirm();"
                class="modal-footer-btn__center"
                float="right"
                :margin-left="2"
                v-show="info.authWay !== 'wechat'"
                :text="currStep >= 3 ? '完成' : '下一步'"
                theme="blue"
            ></normal-button>
            <normal-button
                @click="onPreStep();"
                class="modal-footer-btn__center"
                float="right"
                v-show="currStep < 3"
                text="返回上一步"
                theme="grey"
            ></normal-button>
        </modal-footer>
    </div>
</template>
<style lang="less">
    @import "../../../southcn-ui2/src/assets/less/widgets-var.less";

    .label.modal-auth-complete {
        font-size: 24px;
        height: 60px;
        line-height: 60px;
        color: @otherBigTitleClr;

        .icon.prefix-icon {
            display: inline-block;
            margin-right: 15px;
            color: @primaryBg;
            font-size: 24px;
            transform: scale(1.5);
        }
    }
</style>
<style lang="less" scoped>
    @import "../../../southcn-ui2/src/assets/less/widgets-var.less";

    .row.x1 {
        height: 50px;
    }

    .modal {
        .modal-style;
        min-height: 210px;
        height: 400px;
        width: 560px;

        &.modal-curstep-0,
        &.modal-authway-wechat {
            padding-bottom: 0;
        }

        .modal-content {
            padding: 30px 40px 0 40px;

            .step-panel {
                box-sizing: border-box;
                padding-top: 43px;

                &.step-panel-wechat,
                &.step-panel-wechatBind {
                    text-align: center;
                    padding-top: 13px;
                }

                &.step-panel-0 {
                    text-align: center;
                }

                &.step-panel-sms,
                &.step-panel-phoneBind {
                    padding-top: 23px;
                }

                .wx-bind-frame {
                    height: 140px;
                    overflow: hidden;

                    img {
                        height: 140px;
                        width: 140px;
                    }
                }

                .captcha-view {
                    position: absolute;
                    right: 20px;
                    top: 6px;
                    width: 100px;
                    height: 38px;
                    background-color: #e6e6e6;
                    border-radius: 5px;

                    img {
                        width: 100%;
                        border-radius: 5px;
                        height: 38px;
                    }
                }

                .use-password {
                    .normal-input {
                        width: 380px;

                        &.captcha-input {
                            width: 260px;
                        }
                    }

                    .label {
                        width: 60px;
                    }
                }

                .use-sms {
                    .label {
                        width: 90px;
                        text-align: left;
                    }

                    .normal-input {
                        width: 270px;
                    }

                    .button {
                        width: 105px;
                    }
                }

                .auth-way-btn {
                    width: 260px;
                    display: inline-block;
                }
            }

            .step-box {
                display: flex;
                justify-content: space-between;

                &__item {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    width: 69px;
                    height: 69px;
                    position: relative;

                    &.step-one,
                    &.step-two {
                        &::after {
                            content: "";
                            position: absolute;
                            width: 130px;
                            height: 2px;
                            left: 70px;
                            top: 18px;
                            background: @otherBorderClr;
                        }
                    }

                    &.active {
                        .step-box__item-num {
                            background-color: @primaryBg;
                        }
                    }

                    &.complete {
                        &.step-one,
                        &.step-two {
                            &::after {
                                background: @primaryBg;
                            }
                        }
                    }

                    &.loading {
                        &.step-one,
                        &.step-two {
                            &::after {
                                background: linear-gradient(90deg,
                                rgba(0, 138, 254, 0.58),
                                rgba(216, 218, 221, 0.1));
                            }
                        }
                    }

                    &-num {
                        display: inline-block;
                        width: 36px;
                        height: 36px;
                        color: @whiteBg;
                        text-align: center;
                        border-radius: 100%;
                        line-height: 36px;
                        font-size: @fontSizeTableTitle;
                        background-color: @otherGreyBgClr;
                    }

                    &-text {
                        margin-top: 12px;
                        font-size: @fontSizeTableTitle;
                        color: @otherNormalTitleClr;
                    }
                }
            }
        }
    }
</style>
